import common from "../../common";
import QuestionViewVerbal from "./QuestionViewVerbal";
//import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbalRound extends QuestionViewVerbal {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        } else {
            return "ERROR: NO TEMPLATE FOUND";
        }

        this._template = P3.utils.selectRandom(templates);

        let text = this._template ? this._template.text : "";
        const words = data.words;

        const activites = this.generateWords(this._template.text, words.character_activities, /\[CHARACTER_ACTIVITIES([0-9])?]/g);
        if (activites) {
            for (const i in activites) {
                if (activites.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), activites[i]);
                }
            }
        }

        const specificActivites = this.generateWords(this._template.text, words.specific_activities, /\[CHARACTER_ACTIVITIES([0-9])?]/g);
        if (specificActivites) {
            for (const i in specificActivites) {
                if (specificActivites.hasOwnProperty(i)) {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), specificActivites[i]);
                }
            }
        }

        const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
        for (const i in values) {
            if (values.hasOwnProperty(i)) {
                // text = text.replace(new RegExp(P3.utils.escape(i), "g"), Math.random() < 0.5 ? values[i] : converter.toWords(values[i]));
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
            }
        }

        const length = this.generateValues(this._template.text, /\[LENGTH]/g);
        for (const i in length) {
            if (length.hasOwnProperty(i)) {
                //  text = text.replace(new RegExp(P3.utils.escape(i), "g"), Math.random() < 0.5 ? this._question.length : converter.toWords(this._question.length));
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), this._question.length);
            }
        }

        const match = text.match(/\. [a-z]/g);
        if (match) {
            for (let i = 0; i < match.length; ++i) {
                const s = match[i];
                text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
            }
        }

        return text;
    }

    isCorrect() {
        return parseInt(this._inputValue) === parseInt(this._question.answer.value);
    }

    filterTemplate(x) {
        return true;
    }
}